import { Box, Text } from '@wix/design-system';
import React, { useCallback, useContext, useState } from 'react';

import { ModalServiceContext, RicosContext } from './../../../ricos-context';

import { KEYBOARD_NAVIGATION_TOOLTIP } from './data-hooks';

const MODAL_ID = 'keyboard-navigation-tooltip';

export const useKeyboardNavigationTooltip = () => {
  const modalService = useContext(ModalServiceContext);
  const [hasTooltipShown, setHasTooltipShown] = useState(false);

  const openTooltip = useCallback(
    (referenceElement: HTMLDivElement | null) => {
      if (hasTooltipShown || !referenceElement) {
        return;
      }

      const isModalOpen = modalService.isModalOpen(MODAL_ID);

      if (isModalOpen) {
        modalService.closeModal(MODAL_ID);
        return;
      }

      modalService.openModal({
        id: MODAL_ID,
        Component: KeyboardNavigationTooltipContent,
        positioning: { placement: 'top-start', referenceElement },
        layout: 'popover',
        noPadding: true,
        componentProps: {},
      });
      setHasTooltipShown(true);
    },
    [modalService, hasTooltipShown]
  );

  const closeTooltip = useCallback(() => {
    if (!modalService.isModalOpen(MODAL_ID)) {
      return;
    }
    modalService.closeModal(MODAL_ID);
  }, [modalService]);

  return { openTooltip, closeTooltip };
};

const KeyboardNavigationTooltipContent: React.FC = () => {
  const { t } = useContext(RicosContext);

  return (
    <Box padding="SP1" backgroundColor="D10" dataHook={KEYBOARD_NAVIGATION_TOOLTIP}>
      <Text size="small" skin="standard" weight="thin" light>
        {t('Editor_KeyboardNavigation_Tooltip')}
      </Text>
    </Box>
  );
};
